/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Copyright (c) 2013 MOCA Systems, Inc.  All rights reserved.
 *
 * src/main/resources/com/mocasystems/mb4/ui/ng/ticketspace-directives.js
 *
 * Angular directives for ticketspace-app.js.
 */
'use strict';

import * as angular from 'angular';

import { TicketCreatorService } from 'src/app/services/ticket-creator.service';

import * as strings from '@touchplan/strings';
import { TicketEditCommonDesktopService } from '../../common/docked-ticket/services/ticket-edit-common-desktop.service';

angular.module('ticketspaceApp').directive('floatingTickets', [
	'$parse',
	function ($parse) {
		// const logger = loggerServiceFactory.create('floatingTickets');
		return {
			restrict: 'EA',
			template: require('html-loader?root=src/!tpl/floating-tickets.html'),
			scope: true,
			controllerAs: 'ctrl',
			bindToController: {
				api: '=',
				roles: '=',
			},
			controller: [
				'$scope',
				'$timeout',
				'ticketCreatorService',
				'ticketEditCommonDesktopService',
				'$filter',
				function (
					$scope,
					$timeout,
					ticketCreatorService: TicketCreatorService,
					ticketEditCommonDesktopService: TicketEditCommonDesktopService,
					$filter
				) {
					const self = this;
					$scope.highlightAddTicket = false;

					this.$onInit = () => {
						$scope.$watch('ctrl.api', () => {
							rebuildApi();
							$scope.update();
						});
					};

					this.hasRoleAccess = (defaultRoleId: string) => {
						if (!$filter('hasRole')(defaultRoleId, $scope.roles.fb)) {
							Logging.warning(strings.TICKET_ERRORS_EDIT_INVALID_WHEN_ADDING_WITH_NO_ROLE);
							return false;
						} else {
							return true;
						}
					};

					this.resolveOpenEdit = () => {
						const isEditOpen = ticketEditCommonDesktopService.isTicketEditOpenSync();
						if (isEditOpen) {
							const editValid = ticketEditCommonDesktopService.isEditValidSync();
							if (!editValid) {
								Logging.warning(strings.TICKET_ERRORS_EDIT_INVALID_WHEN_ADDING);
								return false;
							} else {
								return ticketEditCommonDesktopService.trySaveAndClose();
							}
						}
						return true;
					};

					// New Edit constraint colors
					this.getAssignedRoleId = function (ticket) {
						const assignedPmId =
							ticket.data && ticket.data.assignedProjectMemberId ? ticket.data.assignedProjectMemberId : null;
						const record = $scope.meshedUsers.$getPmRecord(assignedPmId);
						const primaryRole = record ? record.data.roleId : '';
						return ticket.data.assignedProjectMemberRoleId
							? ticket.data.assignedProjectMemberRoleId
							: primaryRole;
					};

					this.addTask = function () {
						const pm = $scope.you.projectMember || {};
						if (!this.hasRoleAccess(pm.roleId) || !this.resolveOpenEdit()) {
							return;
						}
						const ticketData = ticketCreatorService.getDefaultTask(pm.roleId, pm.$id);

						// If the user has a default crew size, set it on the ticket.
						const storedDefaultCrewSize = $scope.planState.project?.syncObject?.defaultCrewSize;
						if (storedDefaultCrewSize !== undefined) {
							ticketData.crewSize = storedDefaultCrewSize;
						}

						$scope.planState.actions.addTicket(ticketData, $scope.planState.floatingTickets, {
							editImmediately: true,
						});
						this.api.show();
						// floatingRegionApi.show();
					};
					this.addConstraint = function () {
						const pm = $scope.you.projectMember || {};
						if (!this.hasRoleAccess(pm.roleId) || !this.resolveOpenEdit()) {
							return;
						}
						const ticketData = ticketCreatorService.getDefaultConstraint(pm.$id, pm.roleId, pm.$id);
						$scope.planState.actions.addTicket(ticketData, $scope.planState.floatingTickets, {
							editImmediately: true,
						});
						this.api.show();
					};
					this.addMilestone = function () {
						const pm = $scope.you.projectMember || {};
						if (!this.hasRoleAccess(pm.roleId) || !this.resolveOpenEdit()) {
							return;
						}
						const ticketData = ticketCreatorService.getDefaultMilestone(pm.roleId, pm.$id);
						$scope.planState.actions.addTicket(ticketData, $scope.planState.floatingTickets, {
							editImmediately: true,
						});
						this.api.show();
					};

					function rebuildApi() {
						self.api.hide = $scope.hide;
						self.api.show = $scope.show;
						self.api.update = $scope.update;
						self.api.isShown = function () {
							return !$scope.isStashed;
						};
					}
				},
			],
			link(scope: any, element, attrs) {
				const regionElement = element.find('.floating-ticket-region');
				element.addClass('floating-ticket-region-wrapper stash');

				const ticketWidth = 102;

				scope.isLeftEdge = true;
				const scrollOffset = 0;

				let scrollTimeout;

				scope.scroll = function (idx) {
					regionElement.stop(true, true);
					let newScrollLeft = regionElement.scrollLeft();
					const width = ticketWidth * 2;

					const sign = Math.sign(idx);

					if (sign < 0) {
						newScrollLeft = Math.floor((newScrollLeft + width * sign) / width) * width;
					} else {
						newScrollLeft = Math.ceil((newScrollLeft + width * sign) / width) * width;
					}
					if (newScrollLeft > 0) {
						newScrollLeft += 10;
					}
					(regionElement.animate as any)(
						{ scrollLeft: newScrollLeft + 'px' },
						{
							duration: 300,
							complete(now) {
								//scope.$applyAsync(function(){ scope.update(); });
							},
						}
					);
					//scope.update();
				};

				scope.highlightAdd = function () {
					$('.add-ticket-button').addClass('highlight');
					setTimeout(function () {
						$('.add-ticket-button').removeClass('highlight');
					}, 1000);
				};

				scope.isStashed = true;

				scope.toggleStash = function () {
					if (scope.isStashed) {
						scope.show();
					} else {
						scope.hide();
					}
				};

				regionElement.scroll(function () {
					let doSomething = false;

					const scrollLeft = regionElement.scrollLeft();

					if (scrollLeft === 0 && !scope.isLeftEdge) {
						scope.isLeftEdge = true;
						doSomething = true;
					} else if (scrollLeft > 0 && scope.isLeftEdge) {
						scope.isLeftEdge = false;
						doSomething = true;
					}

					const max = regionElement[0].scrollWidth - regionElement.innerWidth();
					//logger.log('scroll', scrollLeft, max, 'width', regionElement[0].scrollWidth, regionElement.innerWidth());
					if (scrollLeft >= max && !scope.isRightEdge) {
						scope.isRightEdge = true;
						doSomething = true;
					} else if (scrollLeft < max && scope.isRightEdge) {
						scope.isRightEdge = false;
						doSomething = true;
					}

					if (doSomething) {
						scope.$applyAsync();
					}
					//todo - arrow is not hiding on drag scroll, can't scroll to max...
					//probably the fault of floatCache...caching (probably also causes ari's firefox bug)
				});

				scope.update = function () {
					if (regionElement.scrollLeft() === 0) {
						scope.isLeftEdge = true;
					} else {
						scope.isLeftEdge = false;
					}
					if (regionElement.scrollLeft() >= regionElement[0].scrollWidth - regionElement.innerWidth()) {
						scope.isRightEdge = true;
					} else {
						scope.isRightEdge = false;
					}
				};

				scope.hide = function () {
					//scope.floatingTickets.selection.empty();
					element.addClass('stash');
					scope.isStashed = true;
				};
				scope.show = function () {
					element.removeClass('stash');
					scope.isStashed = false;
				};
			},
		};
	},
]);
